import { useIntl } from 'react-intl'
import IconButton from '../IconButton/IconButton'
import SearchIcon from '@mui/icons-material/Search'

import messages from './SearchButton.messages'

import { styled } from '@mui/material/styles'

const SearchButtonIcon = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(),
  marginLeft: 'auto',
}))

const SearchButton = () => {

  const intl = useIntl()

  return (
    <SearchButtonIcon
      icon={<SearchIcon />}
      ariaLabel={intl.formatMessage({...messages.ariaLabel})}
    />
  )
}

export default SearchButton
